import type {ReactNode} from 'react'
import {cn} from '@/lib/utils'

export function ReadOnlyNotice({
  children,
  testId,
  className,
}: {
  children: ReactNode
  testId?: string
  className?: string
}) {
  return (
    <p
      data-testid={testId}
      className={cn(
        'surface-divider flex items-start gap-2.5 rounded-xl border border-dashed px-4 py-3 text-sm text-muted-foreground',
        className
      )}>
      <span aria-hidden="true" className="mt-1.5 inline-block size-1.5 shrink-0 rounded-full bg-current opacity-60" />
      <span className="min-w-0">{children}</span>
    </p>
  )
}
